import { CheckCircle2, Copy, ExternalLink } from 'lucide-react';
import { AppShell } from '../components/AppShell.js';
import { Button, Notice } from '../components/ui.js';
import { copy } from '../i18n.js';
import { useDraft } from '../state/DraftContext.js';

export function ConfirmationPage() {
  const { draft, reset } = useDraft();
  if (!draft?.reportReference) return null;
  const t = copy[draft.language];
  return (
    <AppShell language={draft.language}>
      <section className="confirmation-card">
        <CheckCircle2 className="confirmation-icon" aria-hidden />
        <h1>{t.confirmed.title}</h1>
        <p>{t.confirmed.lead}</p>
        <div className="reference-box">
          <span>{t.confirmed.reference}</span>
          <strong>{draft.reportReference}</strong>
          <button
            type="button"
            aria-label="Copy reference"
            onClick={() => void navigator.clipboard.writeText(draft.reportReference ?? '')}
          >
            <Copy size={18} />
          </button>
        </div>
        {draft.trackingUrl ? (
          <div className="flow-actions confirmation-actions">
            <Button onClick={() => window.location.assign(draft.trackingUrl ?? '/')}>
              <ExternalLink size={18} aria-hidden />
              {t.confirmed.openTracking}
            </Button>
            <Button
              variant="secondary"
              onClick={() => void navigator.clipboard.writeText(draft.trackingUrl ?? '')}
            >
              <Copy size={18} aria-hidden />
              {t.confirmed.copyTracking}
            </Button>
          </div>
        ) : null}
        {draft.confirmationEmailState === 'FAILED' ? (
          <Notice tone="warning">{t.confirmed.emailFailed}</Notice>
        ) : null}
        <p className="confirmation-close">{t.confirmed.close}</p>
        <Button
          onClick={() => {
            reset();
            window.location.assign('/report/intake');
          }}
        >
          {t.confirmed.another}
        </Button>
      </section>
    </AppShell>
  );
}
